// SPDX-License-Identifier: AGPL-3.0-or-later

import {
	HideableBadgeFlags,
	PremiumBadgeVisibilityFlags,
	ProfileBadgeVisibilityFlags,
} from '@fluxer/constants/src/UserConstants';
import {SnowflakeStringType} from '@fluxer/schema/src/primitives/SchemaPrimitives';
import {z} from 'zod';

export const FlagBadgeKeySchema = z.enum(
	Object.keys(HideableBadgeFlags) as [keyof typeof HideableBadgeFlags, ...Array<keyof typeof HideableBadgeFlags>],
);
export const PremiumProfileBadgeKeySchema = z.enum(
	Object.keys(PremiumBadgeVisibilityFlags) as [
		keyof typeof PremiumBadgeVisibilityFlags,
		...Array<keyof typeof PremiumBadgeVisibilityFlags>,
	],
);
export const BoostProfileBadgeKeySchema = z.enum(
	Object.keys(ProfileBadgeVisibilityFlags) as [
		keyof typeof ProfileBadgeVisibilityFlags,
		...Array<keyof typeof ProfileBadgeVisibilityFlags>,
	],
);
export const BadgeVisibilityKeySchema = z.union([
	FlagBadgeKeySchema,
	PremiumProfileBadgeKeySchema,
	BoostProfileBadgeKeySchema,
]);

export const CatalogBadgeIdSchema = SnowflakeStringType.max(19).refine(
	(value) => /^[1-9]\d{0,18}$/.test(value) && BigInt(value) <= 9223372036854775807n,
	'Expected a positive signed 64-bit badge ID',
);

export const BADGE_ORDER_MAX = 64;

export const BadgeOrderKeySchema = z.union([BadgeVisibilityKeySchema, CatalogBadgeIdSchema]);
